import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e?.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error } = await supabase?.auth?.signInWithPassword({
        email,
        password,
      });

      if (error) {
        setError(error?.message);
        setLoading(false);
      } else if (data?.session) {
        // Check for redirectTo parameter first, then returnTo, then default to dashboard
        const redirectTo = searchParams?.get('redirectTo') || searchParams?.get('returnTo') || '/admin-dashboard';
        navigate(redirectTo, { replace: true });
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Admin Login - THEPS Newsletter</title>
      </Helmet>
      <div style={{ maxWidth: 400, margin: '80px auto', padding: 20 }}>
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            style={{ width: '100%', padding: 10, marginBottom: 10 }}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e?.target?.value)}
            style={{ width: '100%', padding: 10, marginBottom: 10 }}
            required
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button 
            type="submit" 
            disabled={loading}
            style={{ width: '100%', padding: 10 }}
          >
            {loading ? 'Loading...' : 'Login'}
          </button>
        </form>
      </div>
    </>
  );
};

export default AdminLogin;